import React from 'react';
import {ToastContainer } from 'react-toastify';

const ToastNotification: React.FC = () => {
  
  return (
    <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={'colored'}
    />
  );
};

export default ToastNotification;